export default __webpack_public_path__ + "static/media/MDark.c0483bd5.svg";